import React from "react";
import { useParams } from "react-router-dom";
import ServicePaymentTransactionPage from "pages/servicePayments/NewServicePayment/TransactionPage";
import RefillsTransactionPage from "pages/Refills/refillsTransactionPage";
import PayAfipPage from "pages/afipPayments/TransactionPage";
import { bool } from "prop-types";

const TransactionIndex = ({ isDesktop }) => {
    const { type } = useParams();

    return (
        <>
            {type === "services" && <ServicePaymentTransactionPage isDesktop={isDesktop} />}
            {type === "refills" && <RefillsTransactionPage isDesktop={isDesktop} />}
            {type === "afip" && <PayAfipPage isDesktop={isDesktop} />}
        </>
    );
};

TransactionIndex.propTypes = {
    isDesktop: bool.isRequired,
};

export default TransactionIndex;
